<template>
  <div class="ui-picker-wrapper" :style="{ height: height }">
    <nf-picker-item
      @getSelIndex="getSelIndex"
      v-for="(item, index) in dataCol"
      :key="index"
      :dataList="item"
      :dataIndex="index"
      :cellH="cellH"
      :cellCount="cellCount"
      :ref="'pickerItem' + index"
      :labelKey="labelKey"
    ></nf-picker-item>
  </div>
</template>

<script>
import nfPickerItem from "./nfPickerItem.vue"
import remToPx from "@/utils/remToPx"

export default {
  name: "nfPicker",
  props: {
    // 数据列表
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    height: {
      type: String,
      default: "4rem"
    },
    cellH: {
      type: Number,
      default: remToPx(0.8)
    },
    cellCount: {
      type: Number,
      default: 5
    },
    labelKey: {
      type: String,
      default: "name"
    }
  },
  data() {
    return {
      dataCol: [],
      selItem: [],
      dataDeep: 1,
      selArr: [] // 当前选择的下标集合
    }
  },
  components: {
    nfPickerItem
  },
  methods: {
    // 获取当前选中的index
    getSelIndex(data) {
      const isSame = this.selArr[data.key] == data.index
      this.selArr[data.key] = data.index
      if (data.key == 0 && !isSame) {
        const hasChild = Array.isArray(this.dataList[this.selArr[0]].childOrg)
        if (hasChild) {
          this.setChildArr(1, this.dataList[this.selArr[0]])
          this.refreshChild(1)
          this.selArr[1] = 0
          const hasSecondChild = Array.isArray(this.dataList[this.selArr[0]].childOrg[0].childOrg)
          if (hasSecondChild) {
            this.setChildArr(2, this.dataList[this.selArr[0]].childOrg[0])
            this.refreshChild(2)
            this.selArr[2] = 0
          }
        }
      }
      if (data.key == 1 && !isSame) {
        const hasChild = Array.isArray(this.dataList[this.selArr[0]].childOrg[this.selArr[1]].childOrg)
        if (hasChild) {
          this.setChildArr(2, this.dataList[this.selArr[0]].childOrg[this.selArr[1]])
          this.refreshChild(2)
          this.selArr[2] = 0
        }
      }
      if (this.timer) {
        window.clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = window.setTimeout(() => {
        const resultObj = {}
        this.selArr.forEach((selIndex, index) => {
          const parentArr = index < 1 ? this.dataList : resultObj[index - 1].childOrg
          parentArr && (resultObj[index] = { ...parentArr[selIndex] })
        })
        Object.keys(resultObj).forEach(index => {
          delete resultObj[index].childOrg
          this.selItem[index] = resultObj[index]
        })
        this.$emit("getSelItem", this.selItem)
        this.$emit("getSelIndex", this.selArr)
      })
    },
    // 处理数据
    resolveData() {
      this.dataCol = []
      this.dataCol.push(this.dataList)
      this.selArr[0] = 0
    },
    // 设置子数组
    setChildArr(index = 1, parent = this.dataList[0]) {
      const hasChild = Array.isArray(parent.childOrg)
      if (!hasChild) return
      this.dataDeep = index + 1
      this.$set(this.dataCol, index, parent.childOrg)
    },
    // 刷新子列
    refreshChild(index = 1) {
      let key = `pickerItem${index}`
      this.$refs[key][0].refresh()
    },
    init() {
      if (this.dataList.length === 0) return
      this.resolveData()
      this.setChildArr()
      if (this.dataList[0].childOrg && Array.isArray(this.dataList[0].childOrg[0].childOrg)) {
        this.setChildArr(2, this.dataList[0].childOrg[0])
      }
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    dataList() {
      this.init()
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-picker-wrapper {
  background: #ffffff;
  overflow: hidden;
  display: flex;
  width: 100%;
}
</style>
